import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { t } from 'i18next';
import ImageItem from '../image-item/large';
import Popover from './popover';

const defaultUser = { full_name: t('core:delete_user'), profile_img: '' };

class Profile extends PureComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    children: PropTypes.any,
    className: PropTypes.string,
    meta: PropTypes.any,
    size: PropTypes.number,
    enablePopover: PropTypes.bool,
    onClick: PropTypes.func,
    showExtraIcon: PropTypes.node,
    onNameClick: PropTypes.func,
    nameWrapper: PropTypes.func,
    fullComponentWrapper: PropTypes.func,
  };

  static defaultProps = {
    enablePopover: false,
  };

  render() {
    const {
      children, className, size, meta, enablePopover, onClick,
      showExtraIcon, onNameClick, nameWrapper, fullComponentWrapper,
    } = this.props;

    const user = this.props.user || defaultUser;
    const metaText = typeof meta === 'string' ? <small>{meta}</small> : meta || null;

    let _className = `Profile${className ? ` ${className}` : ''}`;
    if (onClick) {
      _className += ' pointer';
    }
    let nameClassName = user.nameClassName ? ` ${user.nameClassName}` : '';
    if (onNameClick) {
      nameClassName += ' pointer';
    }

    const imageItem = (
      <ImageItem
        mask
        className={_className}
        image={user.profile_img}
        name={user.full_name}
        meta={metaText}
        imageSize={size}
        ImageWrapper={enablePopover ? Popover : null}
        wrapperProps={{ user }}
        onClick={onClick}
        onNameClick={onNameClick}
        nameClassName={nameClassName}
        showExtraIcon={showExtraIcon}
        nameWrapper={nameWrapper}
      >
        {children}
      </ImageItem>
    );

    return fullComponentWrapper ? fullComponentWrapper(imageItem) : imageItem;
  }
}

export default Profile;
